import format from 'format-number';
const formatNumber = number => {
	const valueFormated = format({
		decimalsSeparator: ',',
		round: 2,
	})(number, {});
	return valueFormated;
};
export default formatNumber;
